import Confetti from "react-confetti";
import { customer } from "~/api/config";
import { isValentinesSeason } from "~/molecules/ValentineGift";

interface Props {
  show: boolean;
  onComplete: () => void;
}

export const DocumentConfetti = ({ show, onComplete }: Props) => {
  const canvasWidth =
    window.innerWidth -
    (window.innerWidth - document.documentElement.clientWidth);

  const canvasHeight =
    window.innerHeight -
    (window.innerHeight - document.documentElement.clientHeight);

  const customerColors: Record<string, string[]> = {
    // Djurgården IF brand colors reference: https://profile.dif.se/color.html
    dif: [
      "#002554",
      "#002554",
      "#002554", // Mörkblå (Dark Blue) - repeated for emphasis
      "#cfb571",
      "#cfb571",
      "#cfb571", // Guld (Gold) - repeated for emphasis
    ],
  };

  const customColors = customer ? customerColors[customer] : undefined;

  return (
    <Confetti
      width={canvasWidth}
      height={canvasHeight}
      run={show}
      recycle={false}
      colors={customColors}
      confettiSource={{
        x: canvasWidth,
        y: canvasHeight,
        w: 0,
        h: 0,
      }}
      initialVelocityX={30}
      initialVelocityY={40}
      tweenDuration={1000}
      gravity={0.5}
      drawShape={
        isValentinesSeason
          ? (ctx) => {
              ctx.beginPath();
              ctx.moveTo(0, 0);
              // Left curve
              ctx.bezierCurveTo(-6, -6, -12, 0, 0, 12);
              // Right curve
              ctx.bezierCurveTo(12, 0, 6, -6, 0, 0);
              ctx.fillStyle = "#FF69B4";
              ctx.fill();
              ctx.closePath();
            }
          : undefined
      }
      onConfettiComplete={onComplete}
    />
  );
};
